import { TipoAcompanhamentoEnum, VulnerabilidadeFamiliar } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'
import { AcompanhamentoCard } from 'view/atendimentos/detail/acompanhamentos/components/AcompanhamentoCard'

import { ProntuarioCard } from '../ProntuarioCard'
import { AcompanhamentoVulnerabilidadeCard } from './AcompanhamentoVulnerabilidadeCard'

interface AcompanhamentoVulnerabilidadeContentProps {
  tipoAcompanhamento?: TipoAcompanhamentoEnum
  loading: boolean
  showAcompanhamentoVulnerabilidade: boolean
  isBeneficiarioBolsaFamilia: boolean
  dataRegistro: LocalDate
  bolsaFamiliaTooltipText?: string
  titleColor?: string
  vulnerabilidade?: VulnerabilidadeFamiliar
  showModalButton?: boolean
}

export const AcompanhamentoVulnerabilidadeContent = (props: AcompanhamentoVulnerabilidadeContentProps) => {
  const {
    tipoAcompanhamento,
    loading,
    showAcompanhamentoVulnerabilidade,
    isBeneficiarioBolsaFamilia,
    dataRegistro,
    bolsaFamiliaTooltipText,
    titleColor,
    vulnerabilidade,
    showModalButton,
  } = props

  const renderVulnerabilidadeCard = () => (
    <AcompanhamentoVulnerabilidadeCard
      dataRegistro={dataRegistro}
      isBeneficiarioBolsaFamilia={isBeneficiarioBolsaFamilia}
      bolsaFamiliaTooltipText={bolsaFamiliaTooltipText}
      vulnerabilidade={vulnerabilidade}
      showModalButton={showModalButton}
    />
  )

  if (!isUndefinedOrNull(tipoAcompanhamento)) {
    return (
      <AcompanhamentoCard
        id='acompanhamento-vulnerabilidade'
        title='Acompanhamento de vulnerabilidade'
        tipoAcompanhamento={tipoAcompanhamento}
        loading={loading}
        placeholder='Nenhuma vulnerabilidade registrada'
      >
        {showAcompanhamentoVulnerabilidade && renderVulnerabilidadeCard()}
      </AcompanhamentoCard>
    )
  } else if (loading) {
    return null
  } else if (showAcompanhamentoVulnerabilidade) {
    return (
      <ProntuarioCard title='Acompanhamento de vulnerabilidade' titleColor={titleColor}>
        {renderVulnerabilidadeCard()}
      </ProntuarioCard>
    )
  } else {
    return null
  }
}
